"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ITEMS_MENU = void 0;
exports.ITEMS_MENU = [
    {
        index: 0,
        label: 'All Reviews',
    },
    {
        index: 1,
        label: 'Active Reviews Assigned to Me',
    },
    {
        index: 2,
        label: 'Reviews I Created',
    },
];
